export default __webpack_public_path__ + "static/media/1.88f8b282.jpg";